import { Routes } from '@angular/router';

import { TaRoutes } from '@ta/menu';
import { AuthGuard, FeatureGuard } from '@ta/user';

export enum ECompaniesRoute {
  companies = 'companies',
  myCompany = 'my-company',
  company = 'company',
}

TaRoutes.addRoute({
  key: ECompaniesRoute.companies,
  url: 'companies',
  children: [
    {
      key: ECompaniesRoute.myCompany,
      url: 'my-company',
    },
    {
      key: ECompaniesRoute.company,
      url: 'company/:id',
    },
  ],
});

export const companiesRoutes: Routes = [
  {
    path: TaRoutes.getUrl([ECompaniesRoute.companies, ECompaniesRoute.myCompany]),
    title: 'app.pages.my_company.title',
    loadComponent: () => import('./pages/my-company/my-company').then((c) => c.MyCompanyPage),
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: 'company', level: 'authorize' },
  },
  {
    path: TaRoutes.getUrl([ECompaniesRoute.companies, ECompaniesRoute.company]),
    title: 'app.pages.company.title',
    loadComponent: () => import('./pages/company/company').then((c) => c.PublicCompanyPage),
  },
];
